import { useMediaQuery } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { capitalize } from 'lodash';
import { ReactElement } from 'react';

export interface TitleProps {
  name: string;
  title?: string;
  sx?: BoxProps['sx'];
  textAlign?: TypographyProps['textAlign'];
  whiteSpace?: TypographyProps['whiteSpace'];
}

export default function Title({
  name,
  title,
  sx,
  textAlign = 'center',
  whiteSpace = 'normal',
}: TitleProps): ReactElement {
  const xxlScreen = useMediaQuery('@media (min-width:2560px)');

  const variant = (() => {
    if (xxlScreen) return 'h2';
    if ((title || name).length >= 12) return 'h4';
    return 'h3';
  })();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: '1fr',
        marginBottom: { xs: '-0.3rem', sm: '-0.5rem' },
        pointerEvents: 'none',
        alignItems: 'end',
        ...sx,
        fontSize: 1,
      }}
    >
      <Typography
        variant={variant}
        sx={{
          userSelect: 'none',
          opacity: 1,
          color: 'black',
          gridArea: '1 / 1 / 2 / 2',
          lineHeight: 1,
          textAlign,
          mixBlendMode: 'soft-light',
          whiteSpace,
        }}
      >
        {title || capitalize(name)}
      </Typography>
      <Typography
        variant={variant}
        sx={{
          userSelect: 'none',
          mixBlendMode: 'soft-light',
          backgroundColor: '#000',
          backgroundClip: 'text',
          color: 'transparent',
          textShadow: 'rgba(245,245,245,0.5) 0.5px 0.5px 0.5px',
          gridArea: '1 / 1 / 2 / 2',
          lineHeight: 1,
          textAlign,
          verticalAlign: 'top',
          whiteSpace,
        }}
      >
        {title || capitalize(name)}
      </Typography>
    </Box>
  );
}
